// Camera: dichtbij als je stilstaat, wat verder weg als je rijdt.
// Zuivere berekeningen, zodat het gedrag met tests te bewaken is (BezorgerGame past ze toe).

/** Wereldpixels die je op de korte kant van het scherm ziet als je rijdt. */
export const VIEW_SPAN_MOVING = 480;
/** Zoveel dichterbij kijk je als je stilstaat (1,4 keer zo groot in beeld). */
export const ZOOM_STILL = 1.4;
/** Bij topsnelheid zoomt de camera nog zoveel procent verder uit dan bij normaal rijden. */
export const ZOOM_OUT_AT_SPEED = 0.1;
/** Pas na zoveel seconden stilstaan zoomt de camera in; zo pompt hij niet bij een stoplicht. */
export const STILL_DELAY_SEC = 0.5;
/** Zoveel seconden duurt het erna voordat hij helemaal is ingezoomd. */
export const STILL_RAMP_SEC = 1.2;
const MAX_SPEED = 3.6;

/** Zoom bij het rijden, afhankelijk van de schermgrootte. */
export function baseZoomFor(viewW: number, viewH: number): number {
  return Math.max(0.7, Math.min(1.25, Math.min(viewW, viewH) / VIEW_SPAN_MOVING));
}

const clamp01 = (v: number) => Math.max(0, Math.min(1, v));
/** Zacht in- en uitlopen (smoothstep). */
const smooth = (v: number) => {
  const x = clamp01(v);
  return x * x * (3 - 2 * x);
};

/** Hoe ver ben je ingezoomd? 0 = rijdend, 1 = helemaal ingezoomd na een tijdje stilstaan. */
export function stillFactor(stillTime: number): number {
  return smooth((stillTime - STILL_DELAY_SEC) / STILL_RAMP_SEC);
}

/** De zoom waar de camera naartoe wil. */
export function zoomTarget(base: number, speed: number, stillTime: number): number {
  const speedFrac = clamp01(Math.abs(speed) / MAX_SPEED);
  const inZoom = 1 + (ZOOM_STILL - 1) * stillFactor(stillTime);
  return Math.min(1.9, base * inZoom * (1 - ZOOM_OUT_AT_SPEED * speedFrac));
}

/**
 * Zoom een stap dichter bij het doel. Uitzoomen gaat sneller dan inzoomen: zodra je gaat rijden wil je
 * meteen overzicht, terwijl inzoomen rustig mag.
 */
export function stepZoom(current: number, target: number, dt: number): number {
  const perFrame = target < current ? 0.09 : 0.035;
  return current + (target - current) * (1 - Math.pow(1 - perFrame, dt * 60));
}
